// extracted by mini-css-extract-plugin
export default {"wrapper":"Flag_wrapper_f87ca"};